import React from 'react';
import MiniDrawer from '../../MaterialUI/MiniDrawer';

function DashboardPage(){
    return(
        <MiniDrawer />
    )
}

export default DashboardPage;